import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { reset, doLogout } from '../login/userSlice';
import Link from 'next/link';
import Image from 'next/image';
import styles from '../styles/header/Drawer.module.scss';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPowerOff, faSpinner} from '@fortawesome/free-solid-svg-icons';
import MobileSubmenu from './MobileSubmenu';


const MobileMenu = (props) => {

    const {menuList, closeMenu} = props;
    const [isLoading, editIsLoading] = useState(false);
    const isLoggedIn = useSelector( state=> state.user.isLoggedIn);
    const dispatch = useDispatch();

    const handleLogout = async () => {
        try{   
            editIsLoading(true);
            const resultAction = await dispatch(doLogout('logout')); 
            const response = unwrapResult(resultAction);
           
            if (response.status)  {
                dispatch(reset());
                editIsLoading(false);
            }
          
        } catch(err) {
            editIsLoading(false);
        }  
    }

    const logoutOption = isLoggedIn &&
        <li> 
            <Button onClick={handleLogout} variant="secondary" disabled={isLoading ? true: false}>
                <span>
                    {isLoading ?
                        <FontAwesomeIcon icon={faSpinner} className="" height="16" width="16" />
                    :
                    <>
                        <FontAwesomeIcon icon={faPowerOff} className="me-3" height="16" width="16" />
                        Logout
                    </>
                    }
                </span>
            </Button>
            <hr className={styles.divider} />
        </li>;

    const listHtml = menuList.map( (item, i)=>(

        item.type == 'item' ?
        <li key={i}>
            <Button as={Link} href={item.menuItem.link} onClick={closeMenu} variant="secondary">
                    <span>
                        <FontAwesomeIcon icon={item.icon} className="me-3" height="16" width="16" />
                        {item.menuItem.title}
                    </span>
                </Button>
            <hr className={styles.divider} />
        </li>   
        :
        <MobileSubmenu
            key={i}
            submenu={item}
            closeMenu={closeMenu}
        />
    ));



    return (
        <div className={styles.root} >
            <div className={styles.back} onClick={closeMenu}></div>
            <div className={styles.paperRoot}  >
                <div className={styles.box} >
                    <div className={styles.brand}>
                        <span className="navbar-brand">
                            <Link href={process.env.NEXT_PUBLIC_WEB} title="Conso">

                                <Image src="/images/icons/conso.png" width={111} height={33}  alt="Conso" />

                            </Link>
                        </span>
                    </div>
                    <hr className={styles.divider} />
                    <ul className={styles.list}>
                        {listHtml}
                        {logoutOption}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default MobileMenu;